// extracted by mini-css-extract-plugin
module.exports = {"mobileHeaderHeightSection":"92","mobileHeaderHeightTotal":"184","uvBodyFont":"\"Noto Sans\"","projExpandedAnimDuration":"0.4"};